<template>
<div class="registrationClient">
  <!-- Компонент registrationClient -->
  <form @submit.prevent="submit">
    <v-text-field
      label="Введите фамилию"
      v-model="userData.first_name"
      @input="clearError"
      @blur="$v.userData.first_name.$touch()"
      :error-messages="firstNameErrors"
      :error="!!errors.createClient.find((err) => err[0] === 'non_field_errors')"
      outlined
    />
    <v-text-field
      label="Введите имя"
      v-model="userData.last_name"
      @input="clearError"
      @blur="$v.userData.last_name.$touch()"
      :error-messages="lastNameErrors"
      :error="!!errors.createClient.find((err) => err[0] === 'non_field_errors')"
      outlined
    />
    <v-text-field
      label="Введите отчество"
      v-model="userData.patronymic"
      @input="clearError"
      @blur="$v.userData.patronymic.$touch()"
      :error-messages="patronymicErrors"
      :error="!!errors.createClient.find((err) => err[0] === 'non_field_errors')"
      outlined
    />
    <v-text-field
      label="Введите телефон"
      v-model="userData.phone"
      @input="clearError"
      @blur="$v.userData.phone.$touch()"
      :error-messages="phoneErrors"
      :error="!!errors.createClient.find((err) => err[0] === 'non_field_errors')"
      outlined
    />
    <v-text-field
      label="Введите имя в Telegram"
      v-model="userData.telegram"
      @input="clearError"
      @blur="$v.userData.telegram.$touch()"
      :prefix="'@'"
      :error-messages="telegramErrors"
      :error="!!errors.createClient.find((err) => err[0] === 'non_field_errors')"
      outlined
    />
    <v-text-field
      label="Введите email"
      v-model="userData.email"
      @input="clearError"
      @blur="$v.userData.email.$touch()"
      :error-messages="emailErrors"
      :error="!!errors.createClient.find((err) => err[0] === 'non_field_errors')"
      outlined
    />
    <div v-for="(err, ind) in errors" :key="ind" class="error--text mt-5">
      <template v-if="Array.isArray(err[1])">
        <div v-for="(e, i) in err[1]" :key="i" class="font-xs">{{e}}</div>
      </template>
      <template v-else>
        <div v-for="(e, i) in err[0]" :key="i" class="font-xs">{{e}}</div>
      </template>
    </div>

    <v-btn type="submit" class="btn-disabled-primary mt-5 w-100"
           x-large color="primary"
           :loading="loading.createClient"
           :outlined="loading.createClient || $v.$invalid"
           :disabled="loading.createClient || $v.$invalid">
      Продолжить
    </v-btn>
  </form>
  <ModalWithAction
    title="Заявка отправлена"
    :image-slot="false"
    :text="'На вашу почту направлены логин и пароль <br>  для перехода в кабинет клиента. <br> Если у вас остались вопросы — свяжитесь с менеджером.'"
    :show-modal="resultsCreated.createClient.success"
    :cancel-button="true"
    :accept-button="'Связаться с менеджером'"
    width-modal="586"
    @accept="goToTelegram"
    @closeModal="closeModal"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          class="text-center"
          src="@/assets/images/adminPanel/success.webp"
          max-width="86px"
        />
      </div>
    </template>
  </ModalWithAction>
</div>
</template>

<script>
import {
 email, maxLength, minLength, required
} from 'vuelidate/lib/validators';
import {
 EMAIL, FIRST_NAME, LAST_NAME, PHONE_NUMBER, TELEGRAM
} from '@/common/constants/validations';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { MESSAGES } from '@/common/constants/errorMessages';
import ModalWithAction from '@/components/admin-panel/Modal/ModalWithAction.vue';

/**
 * Компонент: registrationClient
 * Описание:
 */
export default {
  name: 'registrationClient',

  components: { ModalWithAction },

  validations: {
    userData: {
      first_name: {
        required, maxLength: maxLength(FIRST_NAME.MAX_LENGTH), minLength: minLength(FIRST_NAME.MIN_LENGTH),
      },
      last_name: {
        required, maxLength: maxLength(LAST_NAME.MAX_LENGTH), minLength: minLength(LAST_NAME.MIN_LENGTH),
      },
      patronymic: {
        minLength: minLength(LAST_NAME.MIN_LENGTH),
      },
      phone: {
        required, maxLength: maxLength(PHONE_NUMBER.MAX_LENGTH), minLength: minLength(PHONE_NUMBER.MIN_LENGTH),
      },
      telegram: {
        maxLength: maxLength(TELEGRAM.MAX_LENGTH), minLength: minLength(TELEGRAM.MIN_LENGTH),
      },
      email: {
        required, email, maxLength: maxLength(EMAIL.MAX_LENGTH), minLength: minLength(EMAIL.MIN_LENGTH)
      },
    },

  },

  props: {},

  data: () => ({
    showPass: false,
    userData: {
      first_name: '',
      last_name: '',
      patronymic: '',
      phone: '',
      telegram: '',
      email: '',
    }

  }),
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loggedIn: 'auth/loggedIn',
      loading: 'users/candidate/loading',
      errors: 'users/candidate/errors',
      resultsCreated: 'users/candidate/resultsCreated'
    }),
    firstNameErrors() {
      const errors = [];
      if (!this.$v.userData.first_name.$dirty) return errors;
      if (!this.$v.userData.first_name.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.userData.first_name.maxLength) errors.push(MESSAGES.MAX_LENGTH(FIRST_NAME.MAX_LENGTH));
      if (!this.$v.userData.first_name.minLength) errors.push(MESSAGES.MIN_LENGTH(FIRST_NAME.MIN_LENGTH));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.userData.last_name.$dirty) return errors;
      if (!this.$v.userData.last_name.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.userData.last_name.maxLength) errors.push(MESSAGES.MAX_LENGTH(LAST_NAME.MAX_LENGTH));
      if (!this.$v.userData.last_name.minLength) errors.push(MESSAGES.MIN_LENGTH(LAST_NAME.MIN_LENGTH));
      return errors;
    },
    patronymicErrors() {
      const errors = [];
      if (!this.$v.userData.patronymic.$dirty) return errors;
      if (!this.$v.userData.patronymic.minLength) errors.push(MESSAGES.MIN_LENGTH(LAST_NAME.MIN_LENGTH));
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.userData.phone.$dirty) return errors;
      if (!this.$v.userData.phone.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.userData.phone.maxLength) errors.push(MESSAGES.MAX_LENGTH(PHONE_NUMBER.MAX_LENGTH));
      if (!this.$v.userData.phone.minLength) errors.push(MESSAGES.MIN_LENGTH(PHONE_NUMBER.MIN_LENGTH));
      return errors;
    },
    telegramErrors() {
      const errors = [];
      if (!this.$v.userData.telegram.$dirty) return errors;
      if (!this.$v.userData.telegram.maxLength) errors.push(MESSAGES.INCORRECT_TELEGRAM);
      if (!this.$v.userData.telegram.minLength) errors.push(MESSAGES.INCORRECT_TELEGRAM);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.userData.email.$dirty) return errors;
      if (!this.$v.userData.email.email) errors.push(MESSAGES.INCORRECT_EMAIL);
      if (!this.$v.userData.email.required) errors.push(MESSAGES.REQUIRED);
      return errors;
    },
  },
  methods: {
    ...mapActions({
      createClient: 'users/candidate/createCandidate',
      clearError: 'auth/clearError',
    }),
    ...mapMutations({
      resetCreate: 'users/candidate/resetCreateClient',
    }),
    onInput(field) {
      this.$v[field].$touch();
      if (this.errors.createClient.length) this.clearError();
    },
    async submit() {
      if (this.loading.createClient) return;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const data = {
          email: this.userData.email,
          first_name: this.userData.first_name,
          last_name: this.userData.last_name,
          patronymic: this.userData.patronymic,
          telephone: this.userData.phone,
          telegram: `@${this.userData.telegram}`,
          creator: 0,
        };
        await this.createClient(data);
      }
    },
    goToTelegram() {
      window.open('https://t.me/Team_Assessment', '_blank');
    },
    closeModal() {
      this.userData.first_name = '';
      this.userData.last_name = '';
      this.userData.patronymic = '';
      this.userData.phone = '';
      this.userData.telegram = '';
      this.userData.email = '';
      this.resetCreate();
      this.$router.push('login');
    },
  },
  watch: {
  },
  beforeDestroy() {
    this.clearError();
  },

  created() {
  },

  mounted() {
  },
};
</script>

<style scoped lang="scss">
.registrationClient {
  padding: 16px 0;
  width: 100%;
  max-width: 312px;

  /* Стили компонента */
}
</style>
